
import React, {useRef, useState} from 'react';
import { Timeline } from 'primereact/timeline';
import { Card } from 'primereact/card';
import { Button } from 'primereact/button';
import run from "../../assets/img/milestone/run.svg";
import fotoPerijinan from "../../assets/img/milestone/foto-perijinan.png";
import mulaiBeroperasi from "../../assets/img/milestone/mulai-beroperasi.png";
import pendaftaranOjk from "../../assets/img/milestone/pendaftaran-ojk.png";
import pendirianAft from "../../assets/img/milestone/pendirian-aft.png";
import sertifikasi from "../../assets/img/milestone/sertifikasi-ISO.png";
import bankJombang from "../../assets/img/milestone/bank-jombang-2022.png";
import bankPasuruan from "../../assets/img/milestone/bpr-kota-pasuruan-2022.png";
import bnc from "../../assets/img/milestone/bnc-2021.png";
import anugerahBumi from "../../assets/img/milestone/anugerah-bumi-feb-2023.png";
import cyberUniversity from "../../assets/img/milestone/cyber-university-feb-2023.png";
import developerMei from "../../assets/img/milestone/mei-2023.png";
import glints from "../../assets/img/milestone/glints2023.png";
import hiBank from "../../assets/img/milestone/nov-2023.png";
import jTrust from "../../assets/img/milestone/januari-2024.png";
import bankSaqu from "../../assets/img/milestone/bank-saqu-2024.png";
import btpn from "../../assets/img/milestone/btpn-2024.png";
import bankRaya from "../../assets/img/milestone/bank-raya-2024.png";
import jTrust25 from "../../assets/img/milestone/jtrust-2025.png";
import bankPerdana from "../../assets/img/milestone/bank-perdana-2024.png";
import pegadaian25 from "../../assets/img/milestone/pegadaian-2025.png";
import iso25 from "../../assets/img/milestone/oktober-2025.png";
import jtrust26 from "../../assets/img/milestone/jtrust-2026.png";
import leftRiv from "../../assets/img/icon/arrow-left.riv";
import rightRiv from "../../assets/img/icon/arrow-right.riv";
import Rive from "rive-react";
export default function MilestoneSection() {
    const elementRef = useRef(null);
    const [arrowDisable, setArrowDisable] = useState(true);

    const events = [
        {
            year: 'Sekarang',
            month: '',
            image: '',
            content: '',
        },
        {
            year: 'Sekarang',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Februari 2026',
            image: jtrust26,
            content: 'Melalui skema <em>channeling</em>, <b>PT Bank Jtrust Indonesia Tbk</b> memberikan kepercayaan kembali kepada Danai.id untuk dapat menyalurkan fasilitas kredit inovatif kepada pelaku UMKM baik untuk <em>Invoice</em> maupun <em>Inventory Financing</em>'
        },
        {
            year: '2026',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Oktober 2025',
            image: iso25,
            content: 'Memperoleh Sertifikasi <b>ISO 37001:2016</b> atas sistem Manajemen Anti Penyuapan sebagai komitmen terhadap penetapan kebijakan dan prosedur anti-penyuapan'
        },
        {
            year: '',
            month: 'Juli 2025',
            image: pegadaian25,
            content: 'Bekerja sama dengan <b>PT Pegadaian</b>  dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '',
            month: 'Januari 2025',
            image: jTrust25,
            content: 'Kembali mendapatkan kepercayaan dari <b>PT Bank JTrust Indonesia Tbk</b>, dalam skema <em>channeling</em> bagi pelaku UMKM melalui fasilitas kredit inovatif (pembiayaan persediaan)'
        },
        {
            year: '2025',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Desember 2024',
            image: bankPerdana,
            content: 'Bekerja sama dengan <b>PT BPR Daya Perdana Nusantara</b> (Bank Perdana) dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan Konsumtif (Kredit Multiguna)'
        },
        {
            year: '',
            month: 'Agustus 2024',
            image: bankRaya,
            content: 'Bekerja sama dengan <b>PT Bank  Raya Indonesia</b> (Bank Raya) dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '',
            month: 'April 2024',
            image: bankSaqu,
            content: 'Bekerja sama dengan <b>PT Bank Saqu Indonesia</b> (d/h PT Bank Jasa Jakarta)  dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '',
            month: 'Maret 2024',
            image: btpn,
            content: 'Bekerja sama dengan <b>PT Bank SMBC Indonesia Tbk</b>  dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '',
            month: 'Januari 2024',
            image: jTrust,
            content: 'Bekerja sama dengan <b>PT Bank Jtrust Indonesia Tbk</b> dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '2024',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'November 2023',
            image: hiBank,
            content: 'Bekerja sama dengan <b>PT Bank Hibank Indonesia</b> dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '',
            month: 'Mei 2023',
            image: developerMei,
            content: 'Berkolaborasi dalam mendukung pertumbuhan UMKM melalui pembiayaan Mikro Developer untuk proyek perumahan <b>Parama Residence</b> dan <b>Foresta</b> di Bogor, Jawa Barat.'
        },
        {
            year: '',
            month: 'April 2023',
            image: glints,
            content: 'Terpilih sebagai salah satu aplikasi <em>Peer To Peer Lending</em> terbaik dan tepercaya di Indonesia versi <b>Glints</b>, atas konsistensi layanan keuangan digital yang aman dan andal'
        },
        {
            year: '',
            month: 'Februari 2023',
            image: anugerahBumi,
            content: 'Berkolaborasi dengan <b>PT Anugerah Bumi Seloliman</b> dalam kegiatan pemasaran produk pinjaman EBP <em>(Employee Benefit Program)</em> untuk memperluas jangkauan layanan pembiayaan'
        },
        {
            year: '',
            month: 'Februari 2023',
            image: cyberUniversity,
            content: 'Berkolaborasi dengan <b>Cyber University</b> untuk mendukung dan memajukan pendidikan melalui program magang, pengembangan produk, dan penelitian di bidang industri fintech '
        },
        {
            year: '2023',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Juni 2022',
            image: bankPasuruan,
            content: 'Bekerja sama dengan <b>PT BPR  Kota Pasuruan</b> Indonesia dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '',
            month: 'Januari 2022',
            image: bankJombang,
            content: 'Bekerja sama dengan <b>PT BPR Jombang Perseroda</b> Indonesia dengan skema <em>channeling</em>, dalam memperluas dan meningkatkan akses pembiayaan sektor produktif bagi pelaku UMKM'
        },
        {
            year: '2022',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'Agustus 2021',
            image: fotoPerijinan,
            content: 'Dinyatakan berizin dan diawasi oleh OJK melalui  Keputusan <b>No. KEP-76/D.05/2021 tentang ' +
                'Pemberian Izin Usaha Perusahaan Penyelenggara LPMUBTI, tanggal 19 Agustus 2021</b>'
        },
        {
            year: '',
            month: 'Juli 2021',
            image: bnc,
            content: 'Bekerja sama dengan <b>PT Bank Neo Commerce Tbk</b> Indonesia dengan skema channeling, dalam memperluas dan meningkatkan akses pembiayaan sektor konsumtif'
        },
        {
            year: '2021',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'September 2019',
            image: sertifikasi,
            content: 'Memperoleh Sertifikasi <b>ISO 27001:2013</b> atas sistem Manajemen Keamanan Informasi sebagai komitmen terhadap keamanan data dan kepercayaan pengguna'
        },
        {
            year: '2019',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: '',
            image: '',
            content: '',
        },
        {
            year: '',
            month: 'November 2018',
            image: mulaiBeroperasi,
            content: 'Mulai beroperasi sebagai Lembaga Jasa Keuangan – Layanan Pendanaan Bersama Berbasis Teknologi Informasi (LPBBTI).'
        },
        {
            year: '',
            month: 'Oktober 2018',
            image: pendaftaranOjk,
            content: 'Resmi terdaftar pada Otoritas Jasa Keuangan (OJK) melalui surat <b>No. S-960/NB.213/2018, tanggal 16 Oktober 2018</b>'
        },
        {
            year: '',
            month: 'April 2018',
            image: pendirianAft,
            content: 'PT Adiwisista Finansial Teknologi resmi berdiri di Jakarta, menandai hadirnya Danai.id sebagai penyedia solusi pendanaan berbasis teknologi informasi'
        },
        {
            year: '2018',
            month: '',
            image: '',
            content: '',
        },
    ];

    const customizedMarker = (item, index) => {
        return (
            <div>
                {index === 0 && item.year !== '' ?
                    <img width='300px' src={run} alt='runImage'/>
                    : item.year !== '' ?
                        <Card className="yearCard">
                            <h5>{item.year}</h5>
                        </Card>
                        : item.month === '' ?
                            <div/>
                            : <div className="bullet"/>
                }
            </div>
        );
    };

    const customizedContent = (item, index) => {
        return (
            <div>
                {item.month !== '' ?
                    <Card className="contentCard">
                        <img src={item.image} alt='milestoneCardImage'/>
                        <p><span className="p-card-title">
                            {item.month}</span><br/>
                            <div dangerouslySetInnerHTML={{__html: item.content}} style={{lineHeight:'1.2'}}/>
                        </p>
                    </Card>
                    : item.year !== '' ?
                        index === 0 ?
                            <div style={{width: 200}}/>
                            : <div style={{width: 300}}/> : <div/>
                }
            </div>
        );
    };

    const handleHorizantalScroll = (element, speed, distance, step) => {
        let scrollAmount = 0;
        const slideTimer = setInterval(() => {
            element.scrollLeft += step;
            scrollAmount += Math.abs(step);
            if (scrollAmount >= distance) {
                clearInterval(slideTimer);
            }

            if (element.scrollLeft === 0) {
                setArrowDisable(true);
            } else {
                setArrowDisable(false);
            }
        }, speed);
    };

    return (
        <div className="container-3">
            <div className="section-title">
                <h2 className="text-header"><em>Milestone</em></h2>
                <div className="explanation">
                    <p>Ikuti perjalanan kami dari konsep awal hingga berbagai pencapaian yang telah kami raih hari ini, dengan
                        menelusuri setiap langkah penting yang telah membentuk identitas dan reputasi Danai.id dalam
                        menghadirkan layanan keuangan terbaik bagi Anda.</p>
                </div>
                <div className="arrow-button-mobile">
                    <Button rounded icon="pi pi-arrow-left"
                            onClick={() => {
                                handleHorizantalScroll(elementRef.current, 20, 800, -300);
                            }}
                            disabled={arrowDisable}/>
                    <Button rounded icon="pi pi-arrow-right"
                            onClick={() => {
                                handleHorizantalScroll(elementRef.current, 20, 1000, 300);
                            }}/>
                </div>
            </div>
            <div className="milestone-container">
                <div className="arrow-button">
                    <div className='button-shadow'>
                        <Button rounded
                                onClick={() => {
                                    handleHorizantalScroll(elementRef.current, 20, 800, -300);
                                }}
                                disabled={arrowDisable}>
                            <Rive
                                src={leftRiv}
                                className="rive-button"
                            />
                        </Button>
                    </div>
                    <div className='button-shadow'>
                        <Button rounded
                                onClick={() => {
                                    handleHorizantalScroll(elementRef.current, 20, 1000, 300);
                                }}>
                            <Rive
                                src={rightRiv}
                                className="rive-button"
                            />
                        </Button>
                    </div>
                </div>
                <div className="timelineCard" ref={elementRef}>
                    <Timeline value={events} layout="horizontal" align="alternate" className="customized-timeline"
                              content={customizedContent} marker={customizedMarker}/>
                </div>
            </div>
        </div>
    )
}